import { render, staticRenderFns } from "./PanelCompetitionSettingStatement.vue?vue&type=template&id=2a7db118&scoped=true&"
import script from "./PanelCompetitionSettingStatement.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStatement.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStatement.vue?vue&type=style&index=0&id=2a7db118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7db118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a7db118')) {
      api.createRecord('2a7db118', component.options)
    } else {
      api.reload('2a7db118', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingStatement.vue?vue&type=template&id=2a7db118&scoped=true&", function () {
      api.rerender('2a7db118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingStatement.vue"
export default component.exports